import React from 'react';

import * as buttonConstants from '../buttonConstants';

import Button from '../Button';

import {Icon, iconConstants} from '../../Icon';


function NextButton(props) {

    return (
        <Button
            iconEnd={<Icon icon={iconConstants.ICON_NEXT}/>}
            {...props}
            flavor={buttonConstants.FLAVOR_CONFIRMATION}
        />
    );
}


NextButton.propTypes = {...Button.propTypes};

NextButton.defaultProps = {...Button.defaultProps};


export default NextButton;
